export const TEST_IDS = {
  ENTERPRISE_SECTION_SKELETON: 'enterprise-section-skeleton',
  SECTIONS_SKELETON: 'sections-skeleton',
  TRUST_SIGNAL_SKELETON: 'trust-signal-skeleton',
  SECTION_ENTERPRISE: 'section-enterprise',
  SPONSORED_SECTION_SKELETON: 'sponsored-section-skeleton'
};